module.exports = __webpack_public_path__ + "static/media/elin_swedish.1d84cdda.mp3";